module.exports = __webpack_public_path__ + "static/media/Eliza Lajoie.866d048e.png";